import { render } from "./ConfirmationCode.vue?vue&type=template&id=72fd8b86&scoped=true"
import script from "./ConfirmationCode.vue?vue&type=script&lang=js"
export * from "./ConfirmationCode.vue?vue&type=script&lang=js"

import "./ConfirmationCode.vue?vue&type=style&index=0&id=72fd8b86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72fd8b86"]])

export default __exports__